module.exports = __webpack_public_path__ + "img/29_12.1d3c2cf0.png";